// This file is auto-generated by @hey-api/openapi-ts

export type AdditionalSpecies = {
    species?: string;
    percentage?: number;
};

/**
 * Defines Hubspot deal owner class
 */
export type AddressAnswer = {
    name: string;
    address: AddressText;
};

/**
 * Defines an address structure with text
 */
export type AddressText = {
    text: string;
};

/**
 * The AI segmentation layer is a set of polygons that have been
 * generated by the AI model for determining the land cover of the
 * area.
 */
export type AiSegmentationLayerPrefectLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'ai_segmentation-prefect';
    model_id: string;
    imagery_source: ImageryLayer;
};

export enum type {
    AI_SEGMENTATION_PREFECT = 'ai_segmentation-prefect'
}

/**
 * The AI segmentation layer is a set of polygons that have been
 * generated by the AI model for determining the land cover of the
 * area.
 */
export type AiSegmentationLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'ai_segmentation';
    model_id: string;
    imagery_source: ImageryLayer;
};

export enum type2 {
    AI_SEGMENTATION = 'ai_segmentation'
}

export type AllLayerProperties = SiteBoundaryLayerProperties | SegmentsLayerProperties | SegmentsPrefectLayerProperties | AiSegmentationLayerProperties | AiSegmentationLayerPrefectLayerProperties | ForestLossSegmentationDetailedLayerProperties | ForestLossSegmentationLayerProperties | SourceDataLayerProperties | MpiRegisteredShapefileLayerProperties | CarbonStockVisualLayerProperties | CarbonSequestrationVisualLayerProperties | NoLayerProperties | NoRasterLayerProperties;

export type AlternativeCertification = {
    metadata: AlternativeCertificationMetadata;
    carbon_stock: {
        [key: string]: (number);
    };
    /**
     * Deprecated. This field has been split into native_sequestering and native_steady_state, please use these.
     */
    native?: CarbonStockAndArea;
    /**
     * All native forest whom we attribute sequestration to under the CCU.
     */
    native_sequestering?: CarbonStockAndArea;
    /**
     * All native forest whom we believe to be in a steady state and thus do not attribute sequestration to under the CCU.
     */
    native_steady_state?: CarbonStockAndArea;
    exotic?: CarbonStockAndArea;
};

export type AlternativeCertificationMetadata = {
    version: string;
    timestamp: string;
    hash_v1?: string;
};

export enum AuthFeature {
    UPDATE_CCU_TRACER = 'update_ccu_tracer',
    SITE_EDITOR = 'site_editor',
    INTERNAL = 'internal',
    LANDHOLDER_REPORTS = 'landholder_reports',
    PHOTOS_UPLOADER = 'photos_uploader',
    ADMIN_ALL_COMPANIES = 'admin_all_companies',
    COMPANY_TOOLS = 'company_tools',
    EMISSIONS_RETURN_SURVEY = 'emissions_return_survey',
    CC_INVOICE_MANAGER = 'cc_invoice_manager',
    EDIT_MANAGEMENT_AGREEMENT = 'edit_management_agreement',
    TASK_VIEW = 'task:view',
    TASK_EDIT = 'task:edit',
    GDRIVE_EDIT = 'gdrive:edit'
}

export type Author = {
    full_name?: string;
    email?: string;
};

export type AvailableImageryResponse = {
    layers: Array<ImageryLayer>;
    errors: Array<(string)>;
};

/**
 * Response data module for balance forward query.
 */
export type BalanceForwardResponse = {
    customer_id: number;
    balance_forward: string;
};

export type BaseModel = unknown;

/**
 * The data given to the frontend containing the financial data
 * for a single feature/block
 */
export type BlockEconomics = {
    area: number;
    credit_sales: {
        [key: string]: (number);
    };
    yields: {
        [key: string]: (number);
    };
    start_year: number;
    mpi_fees: {
        [key: string]: (number);
    };
};

export type Body_post_customer_gdrive = {
    file: (Blob | File);
};

export type Body_post_customer_photos_taken = {
    img_files: Array<((Blob | File))>;
};

export type Body_put_company_properties_participant_specific_table_xls = {
    file: (Blob | File);
};

/**
 * Calculation result for payment.
 */
export type CalculatedPayment = {
    balance_brought_forward: string;
    total_payable: string;
    total_paid_now_in_nzu: string;
    total_paid_now_in_nzd: string;
    balance_carried_forward: string;
};

/**
 * Internal data during service fee calculation.
 */
export type CalculatedServiceFee = {
    gross_yield: string;
    costs_ex_tax: string;
    gross_yield_net_costs: string;
    service_fee_ex_tax: string;
};

/**
 * Data model representing what share carboncrop will get - both calculated and
 * overridden values are available
 */
export type CarbonCropShare = {
    calculated: number;
    manual_override?: number;
};

/**
 * The carbon manager is the company that has the "carbon manager" tagged association with the site. This object defines the terms of that agreement.
 */
export type CarbonManagementAgreement = {
    contract_length?: number;
    company_share_proportion?: number;
};

/**
 * The carbon manager is the company that has the "carbon manager" tagged association with the site. This object defines the terms of that agreement.
 */
export type CarbonManagementAgreementWithStartYear = {
    contract_length?: number;
    company_share_proportion?: number;
    contract_start_year?: string;
};

/**
 * Predictions of the carbon price. This is the prediction for the carbon price at
 * the start of the relevant year.
 */
export type CarbonPrices = {
    expected: {
        [key: string]: (number);
    };
    conservative: {
        [key: string]: (number);
    };
    optimistic: {
        [key: string]: (number);
    };
};

/**
 * How fast is this forest absorbing carbon?
 *
 * This layer is generated by CarbonCrop and is used for CCU's
 */
export type CarbonSequestrationVisualLayerProperties = {
    version_created?: VersionData;
    data_type: 'raster';
    max_zoom: number;
    tile_url: string;
    type: 'carbon_sequestration';
    units: 'tCO2e/ha/y';
    code_version: string;
    year_of_visual: number;
    imagery_source: ImageryLayer;
    data_range: Range;
    species_dict: {
        [key: string]: (number);
    };
};

export enum data_type {
    RASTER = 'raster'
}

export enum type3 {
    CARBON_SEQUESTRATION = 'carbon_sequestration'
}

export enum units {
    T_CO2E_HA_Y = 'tCO2e/ha/y'
}

export type CarbonStockAndArea = {
    carbon_stock: {
        [key: string]: (number);
    };
    area_ha: number;
};

/**
 * Represents the carbon stock stored in the forest.
 *
 * This layer is generated by CarbonCrop, and is used for CCU's
 */
export type CarbonStockVisualLayerProperties = {
    version_created?: VersionData;
    data_type: 'raster';
    max_zoom: number;
    tile_url: string;
    type: 'carbon_stock';
    units: 'tCO2e/ha';
    code_version: string;
    year_of_visual: number;
    imagery_source: ImageryLayer;
    data_range: Range;
    species_dict: {
        [key: string]: (number);
    };
};

export enum type4 {
    CARBON_STOCK = 'carbon_stock'
}

export enum units2 {
    T_CO2E_HA = 'tCO2e/ha'
}

/**
 * Prediction of sales for different categories of land
 */
export type Cashflows = {
    total_sale_potential: {
        [key: string]: CreditSalePotential;
    };
};

/**
 * The approximate location of a CarbonCropUnit
 * expressed in WGS84
 */
export type CcuLocation = {
    lat: number;
    lon: number;
};

/**
 * Data model for the post request of CCU.
 */
export type CcuTraceRequest = {
    token_id: number;
    token_type: string;
    issuer: string;
    sequestration_year: string;
    sequestration_type: string;
    polygon_id: number;
    location: CcuLocation;
    time_of_issue: string;
    registry: string;
};

/**
 * The reponse given when requesting data about a sincle CCU.
 * This contains issuing details (eg when/where) as well as the
 * platform that the CCU is currently expected to be trading on.
 */
export type CcuTraceResponse = {
    token_id: number;
    token_type: string;
    issuer: string;
    sequestration_year: string;
    sequestration_type: string;
    polygon_id: number;
    location: CcuLocation;
    time_of_issue: string;
    registry: string;
};

export type ChangeCarbonManagerRequest = {
    company_id: number;
};

export type Comment = {
    text: string;
    author: Author;
    timestamp: string;
    edit_timestamp?: string;
    deleted?: boolean;
};

/**
 * The segments that are used for polygons used for reports
 */
export type CommonGeoJsonProperties = {
    model_s3_key?: string;
    class?: string;
    class_labels?: Array<(string)>;
    /**
     * The credit scheme that this feature is registered under. If no value is provided, it should be interpreted as being the same value as "ets"
     */
    credit_scheme?: 'ets' | 'ets_averaging' | 'ets_stock_change' | 'alternative_scheme' | 'open';
    /**
     * If the polygon attributes update is locked.
     */
    locked?: boolean;
    /**
     * What is the lifecycle stage of future planting.
     */
    planting_status?: 'draft' | 'confirmed' | 'planted';
    /**
     * What is the lifecycle stage of this polygon.
     */
    status?: 'draft' | 'rejected' | 'registered' | 'submitted';
    /**
     * Species according to MPI's ETS species list
     */
    ets_species?: 'douglas_fir' | 'exotic_hardwood' | 'exotic_softwood' | 'indigenous' | 'pinus_radiata' | 'radiata';
    /**
     *  What part of the country is this polygon located in. This is automatically determined.
     */
    ets_region?: 'AUCKLAND' | 'WAIKATO/TAUPO' | 'BAY OF PLENTY' | 'GISBORNE' | 'HAWKES BAY/SOUTHERN NORTH ISLAND' | 'NELSON/MARLBOROUGH' | 'CANTERBURY/WEST COAST' | 'OTAGO' | 'SOUTHLAND';
    /**
     * ISO-8601 date of when the trees were established
     */
    established_date?: string;
    /**
     * High level description of this forest.
     */
    report_category?: 'existing_indigenous_ets_forest' | 'future_native_planting' | 'existing_exotic_ets_forest' | 'future_exotic_planting' | 'potential_ets_forest' | 'scattered_forest' | 'native_carboncrop' | 'pre_1990_forest' | 'other_vegetation' | 'pasture';
    /**
     * The method used to clear the land
     */
    clearance_method?: 'clearance_harvest' | 'adverse_event';
    /**
     * What is the rights between the person applying for the ETS registration and this unit of land.
     * Note: you can only assign one value per carbon accounting area (CAA). If there are four polygons in one CAA, all four of the polygons must have the same type of ownership.
     */
    land_activity_type?: 'land_owner' | 'holder_of_lease' | 'crown_conservation';
    /**
     * ISO-8601 date for the expiry of a registered forestry right or lease over the land.
     */
    lease_expiry_date?: string;
    /**
     * This field shows if a registered forestry right or lease expires at the next harvest.
     */
    lease_expires_next_harvest?: 'yes' | 'no' | 'not_applicable';
    /**
     * ISO-8601 date that a grant provided by the government expires. The date can be in the past or future.
     */
    grant_fund_expiry_date?: string;
    previous_deforestation_date?: string;
    previous_established_date?: string;
    previous_ets_species?: 'douglas_fir' | 'exotic_hardwood' | 'exotic_softwood' | 'indigenous' | 'pinus_radiata' | 'radiata';
    is_excluded?: boolean;
    alternative_certification?: AlternativeCertification;
    financial_start_year?: number;
    ets_caa_number?: number;
    species?: string;
    /**
     * The method used to establish the forest
     */
    establishment_method?: EstablishmentMethod;
    /**
     * The number of stems that were planted. THis is only required for some species
     */
    stem_count?: number;
    descriptor?: string;
    previous_establishment_method?: string;
    previous_species?: string;
    previous_stem_count?: number;
    comments?: Array<(Comment | string)>;
    is_ets_registered?: boolean;
    mature_height_meters?: number;
    mature_canopy_cover_proportion?: number;
    mpi_report?: MpiReportProperties;
    /**
     * Typically the width of the polygon is automatically calculated, but this can be overridden because width is not a mathematical property of a polygon
     */
    width_override?: number;
    ets_registration?: EtsRegistrationDetails;
    ineligible_reasons?: Array<(string)> | string;
    id?: number | string;
    /**
     * The canopy cover of the forest at maturity. This is a number between 0 and 1
     */
    canopy_cover?: number;
    recently_cleared?: boolean;
    recently_planted?: boolean;
    species_percentage?: number;
    additional_species?: Array<AdditionalSpecies>;
    plants_per_hectare?: number;
    plants_spacing_width?: number;
    plants_spacing_length?: number;
    establishment_cost_per_hectare?: number;
};

/**
 * how to display this company so that pages look
 * (more similar) to their own brand look
 */
export type CompanyBranding = {
    header_color?: string;
    header_text_color?: string;
    logo_url?: string;
};

/**
 * Eg address of the company
 */
export type CompanyContact = {
    email_sender?: string;
    email_support?: NamedEmail;
};

/**
 * Represents the relationship between a company and it's customers
 */
export enum CompanyCustomerTags {
    CARBON_MANAGER = 'carbon_manager',
    LEGAL_OWNER = 'legal_owner'
}

export type CompanyEtsRegistrant = {
    name?: string;
    etr_number?: string;
};

/**
 * Company notifications settings.
 */
export type CompanyNotificationSettings = {
    slack_channel_id?: string;
};

/**
 * Company properties data model.
 */
export type CompanyProperties = {
    display_name: string;
    branding?: CompanyBranding;
    company_contact?: CompanyContact;
    per_configuration?: PerDisplayConfig;
    nzu_price?: NZUPrice;
    invoice_config?: InvoiceConfig;
    notifications?: CompanyNotificationSettings;
    default_carbon_management_agreement?: CarbonManagementAgreement;
    participant_specific_table?: ParticipantSpecificTable;
    ets_registrant?: CompanyEtsRegistrant;
};

export type CompanyPropertiesResponse = {
    company_id: number;
    key: string;
    properties?: CompanyProperties;
};

export type CompanyResponse = {
    company_id: number;
    key: string;
};

/**
 * Detailed information about a company user
 */
export type CompanyUserResponse = {
    email: string;
    user_id: number;
    tags: Array<CompanyUserTags>;
};

export enum CompanyUserTags {
    EMPLOYEE = 'employee'
}

/**
 * Information needed to create a company
 */
export type CreateCompanyPost = {
    key?: string;
    properties: CompanyProperties;
};

/**
 * Response data model for new customer.
 */
export type CreateCustomerResponse = {
    customer_id: number;
};

/**
 * User data with submitter.
 */
export type CreateInitialUsers = {
    submitter: UserPostWithMobile;
};

/**
 * Request data model v2 for user and new customer.
 */
export type CreateUserCustomerPost = {
    total_area?: number;
    title_no_list: Array<(string)>;
    site_properties?: CustomerProperties;
    company_key?: string;
    userType?: string;
    survey_data?: HubspotDealProperties;
    users: CreateInitialUsers;
    run_ets_ai?: boolean;
};

export type CreateUserResponse = {
    user_id: number;
    token: string;
};

/**
 * A prediction of dollar values for carbon sales. This is
 * a monetary combination of YieldPotential and CarbonPrices. The year corresponds to
 * the year in which the sequestration happened. For example the 2023 credit sale
 * potential is for sequestration that happened from 1st Jan 2023 to 31st December 2023
 */
export type CreditSalePotential = {
    initial_value_2022: number;
    future_value_to_2050: number;
    cashflows: {
        [key: string]: (number);
    };
};

/**
 * Non-geometric information about a CTR
 */
export type CtrTraceFeatureProperties = {
    methodology_version: string;
    ctr_id: number;
};

/**
 * The response given when requesting details about
 * a single CTR. This is a geojson feature that provides the
 * geometry and some additional metadata in the properties
 * field
 */
export type CtrTraceResponse = {
    type?: string;
    properties: CtrTraceFeatureProperties;
    geometry: {
        [key: string]: unknown;
    };
};

/**
 * A custom tree species with carbon stock
 */
export type CustomSpeciesCarbonStock = {
    /**
     * The unique identifier for the species.
     * These are provided by FCs, but we prepend them with `custom:` before storing in our database.
     */
    id: string;
    /**
     * A user friendly name for the species.
     */
    name: string;
    /**
     * The FOREST_TYPE as defined by MPI in the shapefile attributes for planting and clearing.
     */
    FOREST_TYPE: TupuAkeForestTypeId;
    /**
     * The PREDOMINANT_SPECIES_ID as defined by MPI in the shapefile attributes for planting and clearing.
     */
    PREDOMINANT_SPECIES_ID: TupuAkePredominantSpeciesId;
    /**
     * The TREE_SPECIES_NAME_ID as defined by MPI in the shapefile attributes for planting and clearing.
     */
    TREE_SPECIES_NAME_ID: TupuAkeTreeSpeciesId;
    /**
     * The stock values for this species per region.
     */
    stock: Array<CustomSpeciesStock>;
};

/**
 * Custom species rows for custom carbon tables.
 */
export type CustomSpeciesData = {
    /**
     * The CSV file name of the custom carbon table.
     */
    filename: string;
    /**
     * The custom species for custom carbon tables.
     */
    species: Array<CustomSpeciesCarbonStock>;
};

/**
 * Custom species stock for custom carbon tables.
 */
export type CustomSpeciesStock = {
    /**
     * The ETS Region for this region - matches the ETS region specification.
     */
    region: 'AUCKLAND' | 'WAIKATO/TAUPO' | 'BAY OF PLENTY' | 'GISBORNE' | 'HAWKES BAY/SOUTHERN NORTH ISLAND' | 'NELSON/MARLBOROUGH' | 'CANTERBURY/WEST COAST' | 'OTAGO' | 'SOUTHLAND';
    /**
     * A list of stock values from year 0.
     */
    values: Array<(number)>;
};

export type CustomSpeciesSummary = {
    /**
     * The unique identifier for the species.
     * These are provided by FCs, but we prepend them with `custom:` before storing in our database.
     */
    id: string;
    /**
     * A user friendly name for the species.
     */
    name: string;
    /**
     * The FOREST_TYPE as defined by MPI in the shapefile attributes for planting and clearing.
     */
    FOREST_TYPE: TupuAkeForestTypeId;
    /**
     * The PREDOMINANT_SPECIES_ID as defined by MPI in the shapefile attributes for planting and clearing.
     */
    PREDOMINANT_SPECIES_ID: TupuAkePredominantSpeciesId;
    /**
     * The TREE_SPECIES_NAME_ID as defined by MPI in the shapefile attributes for planting and clearing.
     */
    TREE_SPECIES_NAME_ID: TupuAkeTreeSpeciesId;
    /**
     * The ETS regions this species is planted in.
     */
    regions: Array<('AUCKLAND' | 'WAIKATO/TAUPO' | 'BAY OF PLENTY' | 'GISBORNE' | 'HAWKES BAY/SOUTHERN NORTH ISLAND' | 'NELSON/MARLBOROUGH' | 'CANTERBURY/WEST COAST' | 'OTAGO' | 'SOUTHLAND')>;
};

/**
 * A list of custom species for custom carbon tables.
 */
export type CustomSpeciesSummaryList = {
    /**
     * The custom species for custom carbon tables.
     */
    species: Array<CustomSpeciesSummary>;
};

export type CustomerId = {
    customer_id: number;
};

/**
 * Customer properties data model.
 */
export type CustomerProperties = {
    name?: string;
    userType?: string;
    assignee?: number;
    comment_list?: Array<Comment>;
    mpi_report?: MpiReport;
    carboncrop_share_manual_override?: number;
    financial_start_year?: number;
    no_ccus_reason?: 'not_interested' | 'not_eligible' | 'too_small' | 'phase_2_only';
    carboncrop_share_calculation_version?: string;
    ets?: EtsProperties;
    ai_forest_loss?: Array<FlossyResult>;
    carbon_management_agreement?: CarbonManagementAgreementWithStartYear;
    [key: string]: unknown;
};

/**
 * Feature collection of features where teh ID's may be duplicates,
 * non-integers etc.
 */
export type CustomerSegmentationPost = {
    features: Array<Feature_IdTypes_Union_Polygon__MultiPolygon__CommonGeoJsonProperties_>;
};

/**
 * Customer user association tags.
 */
export enum CustomerUserTags {
    SUBMITTER = 'submitter',
    CONTACT = 'contact',
    EDITOR = 'editor',
    TASK_EDITOR = 'task_editor',
    INVOICE_RECIPIENT = 'invoice_recipient'
}

export type CustomerUsersResponse = {
    users: Array<UserInfoCustomerTagsResponse>;
};

export type CustomersForUser = {
    customer_id: number;
    customer_user_tags: Array<CustomerUserTags>;
    properties: CustomerProperties;
};

/**
 * Dimensions of a site are things we can filter on. They are independent variables, and must be discrete
 */
export type Dimensions = {
    report_category?: 'existing_indigenous_ets_forest' | 'future_native_planting' | 'existing_exotic_ets_forest' | 'future_exotic_planting' | 'potential_ets_forest' | 'scattered_forest' | 'native_carboncrop' | 'pre_1990_forest' | 'other_vegetation' | 'pasture';
    sequestration_status?: 'sequestering' | 'steady_state';
    registration_status?: 'draft' | 'rejected' | 'registered' | 'submitted';
    forest_type: 'exotic' | 'native' | 'unknown' | 'no_forest';
    credit_scheme: 'ets' | 'ets_averaging' | 'ets_stock_change' | 'alternative_scheme' | 'open';
    planting_status?: 'draft' | 'confirmed' | 'planted';
};

export enum forest_type {
    EXOTIC = 'exotic',
    NATIVE = 'native',
    UNKNOWN = 'unknown',
    NO_FOREST = 'no_forest'
}

export type DimsAndMeasures = {
    dimensions: Dimensions;
    measures: Measures;
};

/**
 * A record of if an email has been sent to a specific user
 */
export type EmailLog = {
    to: User;
    email_date: string;
    status: 'sent' | 'bounced';
};

export enum status {
    SENT = 'sent',
    BOUNCED = 'bounced'
}

/**
 * Emission return common data model.
 */
export type EmissionReturn = {
    tupuake_units?: number;
    submitted?: PerStepComplete;
};

export enum EstablishmentMethod {
    DIRECT_PLANTING = 'direct_planting',
    NATURAL_REGENERATION = 'natural_regeneration'
}

/**
 * ETS properties.
 */
export type EtsProperties = {
    mer?: {
    [key: string]: Mer2023Properties;
};
    per?: PerProperties;
    unit_balance?: number;
    unit_balance_updated?: PerStepComplete;
};

export type EtsRegistrationDetails = {
    FOREST_NUM?: number;
    STAND_NUM?: number;
    COMP_NUM?: number;
    [key: string]: unknown;
};

export type Feature = {
    type: 'Feature';
    id?: IdTypes;
    properties: PropertyTypes;
    geometry: GeometryTypes;
};

export enum type5 {
    FEATURE = 'Feature'
}

export type FeatureCollection = {
    type: 'FeatureCollection';
    features: Array<Feature>;
    metadata?: PropertyTypes;
};

export enum type6 {
    FEATURE_COLLECTION = 'FeatureCollection'
}

export type FeatureCollectionWithId_GeometryTypes_PropertyTypes_NoneType_ = {
    type: 'FeatureCollection';
    features: Array<Feature_Annotated_int__Strict_strict_True___GeometryTypes_PropertyTypes_>;
    metadata?: null;
};

export type FeatureCollection_IdTypes_GeometryTypes_CommonGeoJsonProperties_SegmentationMetadata_ = {
    type: 'FeatureCollection';
    features: Array<Feature_IdTypes_GeometryTypes_CommonGeoJsonProperties_>;
    metadata?: SegmentationMetadata;
};

export type FeatureCollection_IdTypes_GeometryTypes_PropertyTypes_SegmentationMetadata_ = {
    type: 'FeatureCollection';
    features: Array<Feature_IdTypes_GeometryTypes_PropertyTypes_>;
    metadata?: SegmentationMetadata;
};

export type FeatureCollection_IdTypes_Union_Polygon__MultiPolygon___FeaturePropertyType__CollectionMetadataType_ = {
    type: 'FeatureCollection';
    features: Array<Feature_IdTypes_Union_Polygon__MultiPolygon___FeaturePropertyType_>;
    metadata?: PropertyTypes;
};

export type FeatureCollection_NoneType_Point_SitePointProperty_NoneType_ = {
    type: 'FeatureCollection';
    features: Array<Feature_NoneType_Point_SitePointProperty_>;
    metadata?: null;
};

export type Feature_Annotated_int__Strict_strict_True___GeometryTypes_PropertyTypes_ = {
    type: 'Feature';
    id?: number;
    properties: PropertyTypes;
    geometry: GeometryTypes;
};

export type Feature_IdTypes_GeometryTypes_CommonGeoJsonProperties_ = {
    type: 'Feature';
    id?: IdTypes;
    properties: CommonGeoJsonProperties;
    geometry: GeometryTypes;
};

export type Feature_IdTypes_GeometryTypes_PropertyTypes_ = {
    type: 'Feature';
    id?: IdTypes;
    properties: PropertyTypes;
    geometry: GeometryTypes;
};

export type Feature_IdTypes_Union_Point__NoneType__PhotoTakenProperties_ = {
    type: 'Feature';
    id?: IdTypes;
    properties: PhotoTakenProperties;
    geometry: Point;
};

export type Feature_IdTypes_Union_Polygon__MultiPolygon__CommonGeoJsonProperties_ = {
    type: 'Feature';
    id?: IdTypes;
    properties: CommonGeoJsonProperties;
    geometry: Polygon | MultiPolygon;
};

export type Feature_IdTypes_Union_Polygon__MultiPolygon__Dict_str__Any__ = {
    type: 'Feature';
    id?: IdTypes;
    properties: {
        [key: string]: unknown;
    };
    geometry: Polygon | MultiPolygon;
};

export type Feature_IdTypes_Union_Polygon__MultiPolygon___FeaturePropertyType_ = {
    type: 'Feature';
    id?: IdTypes;
    properties: PropertyTypes;
    geometry: Polygon | MultiPolygon;
};

export type Feature_NoneType_Point_SitePointProperty_ = {
    type: 'Feature';
    id?: null;
    properties: SitePointProperty;
    geometry: Point;
};

/**
 * AI forest result object.
 *
 * Flossy is the name of our Forest Loss AI Model. This object stores an output
 * summary from an execution of this model.
 */
export type FlossyResult = {
    area_detected: number;
    run_date: string;
};

/**
 * The forest loss segmentation layer is a set of polygons that have been
 * generated by the AI model for determining the forest loss of the
 * area.
 */
export type ForestLossSegmentationDetailedLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'forest_loss_segmentation_detailed';
    model_id: string;
    imagery_source: ImageryLayer;
};

export enum type7 {
    FOREST_LOSS_SEGMENTATION_DETAILED = 'forest_loss_segmentation_detailed'
}

/**
 * The forest loss segmentation layer is a set of polygons that have been
 * generated by the AI model for determining the forest loss of the
 * area.
 */
export type ForestLossSegmentationLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'forest_loss_segmentation';
    model_id: string;
    imagery_source: ImageryLayer;
};

export enum type8 {
    FOREST_LOSS_SEGMENTATION = 'forest_loss_segmentation'
}

export enum ForestTypeKey {
    DOUGLAS_FIR = 'douglas_fir',
    EXOTIC_HARDWOOD = 'exotic_hardwood',
    EXOTIC_SOFTWOOD = 'exotic_softwood',
    INDIGENOUS = 'indigenous',
    RADIATA = 'radiata',
    PINUS_RADIATA = 'pinus_radiata'
}

export type GenericTask = {
    uuid: string;
    assignee?: number;
    customer_id: number;
    site_name?: string;
    update_time?: string;
    task_type: 'assess_ets_eligibility' | 'create_ets_account' | 'register_land_to_ets' | 'transfer_nzus' | 'transfer_ets_participation' | 'remove_land_from_ets';
    status: 'todo' | 'in_progress' | 'review' | 'done' | 'cancelled';
    properties?: GenericTaskProperties;
};

export enum task_type {
    ASSESS_ETS_ELIGIBILITY = 'assess_ets_eligibility',
    CREATE_ETS_ACCOUNT = 'create_ets_account',
    REGISTER_LAND_TO_ETS = 'register_land_to_ets',
    TRANSFER_NZUS = 'transfer_nzus',
    TRANSFER_ETS_PARTICIPATION = 'transfer_ets_participation',
    REMOVE_LAND_FROM_ETS = 'remove_land_from_ets'
}

export enum status2 {
    TODO = 'todo',
    IN_PROGRESS = 'in_progress',
    REVIEW = 'review',
    DONE = 'done',
    CANCELLED = 'cancelled'
}

export type GenericTaskProperties = {
    notes: string;
    comments?: Array<(Comment | string)>;
};

export type GeometryCollection = {
    type: 'GeometryCollection';
    geometries: Array<(Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon)>;
};

export enum type9 {
    GEOMETRY_COLLECTION = 'GeometryCollection'
}

export type GeometryTypes = Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon | GeometryCollection;

export type GetAccessResponse = {
    available_features: Array<AuthFeature>;
};

/**
 * The data that is given to the frontend containing the financial data
 * for the whole project
 */
export type GetFinancePlanResponse = {
    areas: {
        [key: string]: (number);
    };
    yields: {
        [key: string]: YieldPotential;
    };
    mpi_fees: {
        [key: string]: {
            [key: string]: (number);
        };
    };
    cashflows: Cashflows;
    start_year: number;
    carboncrop_share: CarbonCropShare;
};

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

export type HubspotDealProperties = {
    amount?: number;
    assessed_land_area_segment?: string;
    assessed_land_area?: number;
    photos_number_uploaded?: number;
    deal_role?: string;
    land_registered_ets?: string;
    planning_to_plant?: string;
    recent_planting?: string;
    recent_clearance?: string;
    assessment_submission_message?: string;
    how_found_us___other_specified?: string;
    region_new_zealand?: string;
};

/**
 * Response for updating hubspot deals.
 */
export type HubspotDealUpdateResponse = {
    deals_updated: Array<(number)>;
};

export type IdTypes = string | number;

/**
 * Describes a source of XYZ Tiles that can be used to display Raster Imagery on a map
 */
export type ImageryLayer = {
    name: string;
    source?: 'mapbox_imagery' | 'linz_base_map' | 'linz_topographical' | 'linz_aerial_imagery' | 'linz_historical_imagery' | 'retrolens' | 'retrolens_hd' | 'retrolens_hd_survey' | 'planet_imagery' | 'landsat_imagery' | '';
    siteUrl: string;
    tileUrl: string;
    attribution: string;
    startDate?: string;
    endDate?: string;
    extraText?: string;
    minZoom?: number;
    maxZoom?: number;
    tileSize?: number;
    ground_sample_distance?: number;
    geometry_dict?: {
    [key: string]: unknown;
};
    linz_imagery_survey_id?: number;
};

/**
 * Invites a user to a company by email.
 */
export type InviteCompanyUserPost = {
    email: string;
    company_user_tags: Array<CompanyUserTags>;
};

/**
 * Request data for site user invitation.
 */
export type InviteSiteUserPost = {
    email: string;
    customer_user_tags: Array<CustomerUserTags>;
    send_invitation?: boolean;
};

/**
 * Minimal properties for invoice calculation.
 */
export type InvoiceCalculationMinimal = {
    nzus_issued: InvoiceNZUsIssued;
    costs_and_disbursements?: Array<InvoiceCostAndDisbursement>;
    /**
     * Costs and disbursements which were already invoiced to the customer, but need to be included for the service fee calculation.
     */
    already_invoiced_costs_and_disbursements?: Array<InvoiceCostAndDisbursement>;
    sequestration_period: InvoiceSequestrationPeriod;
};

/**
 * Invoice settings for company.
 */
export type InvoiceConfig = {
    bcc?: Array<(string)>;
};

/**
 * Cost and disbursement for invoice.
 */
export type InvoiceCostAndDisbursement = {
    description: string;
    quantity: string;
    total_ex_tax: string;
};

/**
 * Response data module for invoice POST method.
 */
export type InvoiceDataResponse = {
    invoice_id: number;
    invoice_number: string;
    invoice_date: string;
    total_ex_tax: string;
    total_inc_tax: string;
    tax: string;
    status: InvoiceStatus;
    properties: InvoiceProperties;
};

/**
 * Response data model for invoice file ID in Google Drive.
 */
export type InvoiceGoogleDriveFileIdResponse = {
    file_id?: string;
};

/**
 * NZUs issues and NZU price data for invoice.
 */
export type InvoiceNZUsIssued = {
    nzu_price: string;
    amount: string;
};

/**
 * Request used to create an invoice.
 */
export type InvoicePostRequest = {
    invoice_number?: string;
    properties: InvoiceCalculationMinimal;
};

/**
 * Properties of invoice data.
 */
export type InvoiceProperties = {
    nzus_issued: InvoiceNZUsIssued;
    costs_and_disbursements?: Array<InvoiceCostAndDisbursement>;
    /**
     * Costs and disbursements which were already invoiced to the customer, but need to be included for the service fee calculation.
     */
    already_invoiced_costs_and_disbursements?: Array<InvoiceCostAndDisbursement>;
    sequestration_period: InvoiceSequestrationPeriod;
    service_fee_proportion: string;
    cc_service_fee: InvoiceCostAndDisbursement;
    service_fee_calculation: CalculatedServiceFee;
    payment: CalculatedPayment;
};

/**
 * Period of sequestration for invoice.
 */
export type InvoiceSequestrationPeriod = {
    start?: string;
    end: string;
};

/**
 * Invoice status.
 */
export enum InvoiceStatus {
    DRAFT = 'draft',
    SENT = 'sent',
    VOIDED = 'voided'
}

/**
 * Request data module for invoice status update PUT method.
 */
export type InvoiceStatusUpdateRequest = {
    status: InvoiceStatus;
};

export type InvoiceTask = {
    uuid: string;
    assignee?: number;
    customer_id: number;
    site_name?: string;
    update_time?: string;
    task_type: 'invoice';
    status: 'prepare_invoice' | 'awaiting_units' | 'invoice_sent' | 'in_dispute' | 'transaction_prepared' | 'complete' | 'cancelled';
    properties?: InvoiceTaskProperties;
};

export enum task_type2 {
    INVOICE = 'invoice'
}

export enum status3 {
    PREPARE_INVOICE = 'prepare_invoice',
    AWAITING_UNITS = 'awaiting_units',
    INVOICE_SENT = 'invoice_sent',
    IN_DISPUTE = 'in_dispute',
    TRANSACTION_PREPARED = 'transaction_prepared',
    COMPLETE = 'complete',
    CANCELLED = 'cancelled'
}

export type InvoiceTaskProperties = {
    invoice_id?: number;
    email_logs?: Array<EmailLog>;
    prepare_notes?: string;
    dispute_notes?: string;
    dispute_status?: 'no_dispute' | 'in_dispute' | 'resolved';
    invoice_prepared?: PerStepComplete;
    invoice_sent?: PerStepComplete;
    email_sending_status?: 'email_sending' | 'email_failed' | 'email_sent';
    parent_task_id?: string;
};

/**
 * Land use capability classification system for New Zealand land.
 *
 * The LUC system classifies land based on its capability to sustain agricultural production,
 * taking into account physical limitations and soil conservation needs.
 */
export enum LUC {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8
}

/**
 * Information about what layers are available for a customer
 */
export type LayerListModel = {
    customer_id: number;
    layers: Array<LayerModel_AllLayerProperties_>;
};

/**
 * Metadata about a layer: eg what version it is
 */
export type LayerModel = {
    layer_id: number;
    version_id: number;
    properties: AllLayerProperties;
    insert_time?: string;
};

export type LayerModel_AllLayerProperties_ = {
    layer_id: number;
    version_id: number;
    properties: AllLayerProperties;
    insert_time?: string;
};

export type LayerPost_AllLayerProperties_IdTypes_GeometryTypes_PropertyTypes_ = {
    layer_properties: AllLayerProperties;
    features: Array<Feature_IdTypes_GeometryTypes_PropertyTypes_>;
};

export type LineString = {
    type: 'LineString';
    coordinates: Array<[
        number,
        number
    ]>;
};

export enum type10 {
    LINE_STRING = 'LineString'
}

export type Location = {
    lat: number;
    lon: number;
};

/**
 * Measures of a site are things we can aggregate on. They are dependent variables, and can be continuous or discrete
 */
export type Measures = {
    aea: number;
    seq: Array<(number)>;
    luc?: {
    [key: string]: (number);
};
};

/**
 * Data about the 2018-2022 MER (which is filed in 2023).
 * Note: this is not typed on the backend yet. See the frontend code for the data model
 */
export type Mer2023Properties = {
    tupuake_units?: number;
    [key: string]: unknown;
};

/**
 * Layer that is used to store the current view of the site
 * according to the Ministry of Primary Industries (MPI)
 */
export type MpiRegisteredShapefileLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'mpi_registered_shapefiles';
    name: string;
};

export enum type11 {
    MPI_REGISTERED_SHAPEFILES = 'mpi_registered_shapefiles'
}

/**
 * MPI report data model.
 */
export type MpiReport = {
    summary_of_land_status_changes?: string;
    environmental_and_climatic_factors?: string;
    etr_account_id?: string;
    submitter?: MpiSubmitter;
};

export type MpiReportProperties = {
    '0'?: string;
    land_status_1989?: string;
    land_status_1989_map?: ImageryLayer;
    land_status_change_summary?: string;
    land_status_change?: string;
    land_status_at_report_submit?: string;
    land_status_at_report_submit_map?: ImageryLayer;
    group_key?: string;
};

/**
 * Records who submitted the MPI Evidence Report. Generally this should be the account manager
 * who is working with the customer and wrote up the details.
 */
export type MpiSubmitter = {
    name?: string;
    email?: string;
    phone?: string;
};

export type MultiLineString = {
    type: 'MultiLineString';
    coordinates: Array<Array<[
        number,
        number
    ]>>;
};

export enum type12 {
    MULTI_LINE_STRING = 'MultiLineString'
}

export type MultiPoint = {
    type: 'MultiPoint';
    coordinates: Array<Array<(number)>>;
};

export enum type13 {
    MULTI_POINT = 'MultiPoint'
}

export type MultiPolygon = {
    type: 'MultiPolygon';
    coordinates: Array<Array<Array<[
        number,
        number
    ]>>>;
};

export enum type14 {
    MULTI_POLYGON = 'MultiPolygon'
}

export type NZUPrice = {
    file_name: string;
    uploaded_by: User;
    date_uploaded: string;
    enabled: boolean;
    start_year: number;
    values: Array<(number)>;
};

/**
 * An email address with a name.
 *
 * Many email clients support displaying a name alongside an email address.
 * For example: "Support Team" and "support@company.com"
 */
export type NamedEmail = {
    name: string;
    email: string;
};

/**
 * This layer has no properties
 */
export type NoLayerProperties = {
    version_created?: VersionData;
    type?: null;
    data_type?: null;
};

/**
 * This layer has no additional properties beyond the strictly necessary.
 */
export type NoRasterLayerProperties = {
    version_created?: VersionData;
    data_type: 'raster';
    max_zoom: number;
    tile_url: string;
    type?: null;
};

export type ParcelStatus = {
    parcel_id: number;
    status: 'Current' | 'Historic' | 'Approved as to Survey' | 'Survey Historic';
};

export type ParcelStatusResponse = {
    customer_id: number;
    parcel_status: Array<ParcelStatus>;
    projects_sharing_parcels: Array<(number)>;
};

/**
 * If an ETS registrant has more than 100Ha of registered forest, the forest is measured to find out the carbon
 * it is storing. MPI then averages this across a participants registered land to get a carbon stock per hectare
 * for each forest type. This is then used to calculate the carbon stock for the participant's land.
 */
export type ParticipantSpecificTable = {
    data: Array<ResidualAndStock>;
    table_generated_date?: string;
    upload_date?: string;
};

/**
 * Data module for payment.
 */
export type PaymentResponseData = {
    invoice_id: number;
    amount: string;
    currency: string;
    currency_rate: string;
    status: PaymentStatus;
    payment_id: number;
};

/**
 * Payment status.
 */
export enum PaymentStatus {
    PENDING = 'pending',
    STARTED = 'started',
    CLEARED = 'cleared'
}

/**
 * Request data module for payment status update.
 */
export type PaymentStatusUpdateRequest = {
    status: PaymentStatus;
};

/**
 * PER 2023 data model.
 */
export type Per2023Properties = {
    prepare?: PerPrepare;
    landholder_input?: PerLandholderInput;
    process_changes?: PerProcessChanges;
    submission?: PerEmissionReturn;
    invoice_uploaded_to_google_drive?: boolean;
};

/**
 * Represents a Provisional Emissions Return (PER)
 */
export type Per2023Task = {
    uuid: string;
    assignee?: number;
    customer_id: number;
    site_name?: string;
    update_time?: string;
    task_type: 'per';
    status: 'no_per' | 'prepare' | 'landholder_input' | 'process_changes' | 'submit' | 'finish';
    properties?: PerTaskProperties;
};

export enum task_type3 {
    PER = 'per'
}

export enum status4 {
    NO_PER = 'no_per',
    PREPARE = 'prepare',
    LANDHOLDER_INPUT = 'landholder_input',
    PROCESS_CHANGES = 'process_changes',
    SUBMIT = 'submit',
    FINISH = 'finish'
}

/**
 * Represents a Provisional Emissions Return (PER) 2024
 */
export type Per2024Task = {
    uuid: string;
    assignee?: number;
    customer_id: number;
    site_name?: string;
    update_time?: string;
    task_type: 'per.2024';
    status: 'no_per' | 'prepare' | 'landholder_input' | 'process_changes' | 'submit' | 'finish';
    properties?: PerTaskProperties;
};

export enum task_type4 {
    PER_2024 = 'per.2024'
}

/**
 * PER change data model.
 *
 * Some information we want about the PER is about certain types of land change. If there are changes
 * we want more information from the user (ie a free text field), but if there are no changes then we don't.
 *
 * This data model provides a way to record if there are changes, and if so what they are.
 */
export type PerChange = {
    has_change?: boolean;
    change_details?: string;
};

/**
 * Does the landowner want us to file a PER for them?
 * If not, why not?
 *
 * Generally we expect that users will want us to file a PER for the
 * as it results in a higher payment. So if they don't want us to, we want to
 * know why.
 */
export type PerConfirmation = {
    confirmed?: boolean;
    lost_reason?: string;
};

/**
 * PER 2023 display configuration.
 */
export type PerDisplayConfig = {
    enabled?: boolean;
    show_landholder_confirmation: boolean;
};

/**
 * PER 2023 email sending record data model.
 */
export type PerEmail = {
    to: User;
    email_date: string;
    status: 'sent' | 'opened' | 'completed' | 'bounced';
};

/**
 * Data model for PER email invitation.
 */
export type PerEmailPost = {
    email: string;
    task_uuid: string;
};

/**
 * PER emission return. THe two different accounting methods available require
 * filing separate emission returns.
 */
export type PerEmissionReturn = {
    standard?: EmissionReturn;
    permanent?: EmissionReturn;
};

/**
 * PER 2023 landholder input step data model.
 *
 * This step is completed by the landowner, and records information that an account manager cannot
 * determine by looking at aerial imagery.
 */
export type PerLandholderInput = {
    email_logs?: Array<PerEmail>;
    property_changes?: boolean;
    ownership_changes: PerChange;
    forest_changes: PerChange;
    caa_changes: PerChange;
    additional_changes?: string;
    per_confirmation: PerConfirmation;
    step_complete?: PerStepComplete;
};

/**
 * The initial setup step of the PER. This records if there are
 * any issues with the land that would prevent us from filing a PER.
 */
export type PerPrepare = {
    change_accounting_method?: boolean;
    change_accounting_method_v2?: 'no' | 'to_be_changed' | 'changed';
    forest_loss_mapping?: 'no' | 'to_map' | 'mapped';
    file_per?: boolean;
    step_complete?: PerStepComplete;
};

/**
 * PER process changes step data model.
 *
 * This comes after the landowner survey, and contains the tasks that the landowner has to do in
 * direct response to the landowner survey.
 */
export type PerProcessChanges = {
    property_changes?: ProcessPropertyChanges;
    ownership_changes?: ProcessOwnershipChanges;
    forest_changes?: ProcessForestChanges;
    caa_changes?: ProcessCaaChanges;
    additional_changes?: ProcessAdditionalChanges;
    step_complete?: PerStepComplete;
};

/**
 * PER properties for different years.
 */
export type PerProperties = {
    y2023: Per2023Properties;
};

/**
 * PER 2023 step completion data.
 *
 * For some PER steps it is necessary to record who completed the step and when.
 * For example if the land is owned by a trust, which user filled in the landowner survey?
 * This allows auditing of the process, and knowing who to contact if there are any questions or issues.
 * This can also be used for internal-only-steps, if there are more review processes.
 */
export type PerStepComplete = {
    by: User;
    date: string;
};

/**
 * Note that the PER task properties.
 */
export type PerTaskProperties = {
    prepare?: PerPrepare;
    landholder_input?: PerLandholderInput;
    process_changes?: PerProcessChanges;
    submission?: PerEmissionReturn;
    invoice_uploaded_to_google_drive?: boolean;
};

export type PhotoArchivedBody = {
    archived: boolean;
};

export type PhotoTakenProperties = {
    file_name: string;
    file_id: string;
    archived: boolean;
    upload_date: string;
    taken_date?: string;
};

export type Point = {
    type: 'Point';
    coordinates: Array<(number)>;
};

export enum type15 {
    POINT = 'Point'
}

export type Polygon = {
    type: 'Polygon';
    coordinates: Array<Array<[
        number,
        number
    ]>>;
};

export enum type16 {
    POLYGON = 'Polygon'
}

/**
 * Process additional changes. This is related to the `additional_changes` field in the landowner survey
 */
export type ProcessAdditionalChanges = {
    confirmed?: boolean;
    notes?: string;
};

/**
 * Process CAA removal changes. This is related to the `caa_changes` field in the landowner survey
 */
export type ProcessCaaChanges = {
    confirmed?: boolean;
    notes?: string;
    processed?: boolean;
};

/**
 * Process forest details changes. This is related to the `forest_changes` field in the landowner survey
 */
export type ProcessForestChanges = {
    confirmed?: boolean;
    notes?: string;
    shapefile_uploaded?: boolean;
    request_submitted?: boolean;
};

/**
 * Process ownership changes. This is related to the `ownership_changes` field in the landowner survey
 */
export type ProcessOwnershipChanges = {
    confirmed?: boolean;
    notes?: string;
    processed?: boolean;
};

/**
 * Process property changes, such as land being subdivided or sold.
 */
export type ProcessPropertyChanges = {
    confirmed?: boolean;
    notes?: string;
    transfer_form_completed?: boolean;
    request_submitted_and_paid?: boolean;
};

/**
 * Properties of a customer/property.
 */
export type PropertyProperties = {
    name?: string;
    assignee?: number;
};

export type PropertyTypes = {
    [key: string]: unknown;
} | BaseModel;

/**
 * Response data module for credit note query.
 */
export type QueryCreditNoteResponse = {
    customer_id: number;
    credit_note_id: string;
    date: string;
    description: string;
    total: number;
};

/**
 * Wrapper class for a numerical range defined by a minimum and a maximum.
 */
export type Range = {
    min: number;
    max: number;
};

/**
 * Carbon stock curves for a single forest type
 */
export type ResidualAndStock = {
    forest_type: ForestTypeKey;
    stock: Array<(number)>;
    residual: Array<(number)>;
};

/**
 * Metadata about a segmentation layer: eg what version it is
 */
export type SegmentationMetadata = {
    version_id: number;
    user_id: number;
    timestamp?: string;
};

/**
 * Response data model for updating segmentation.
 */
export type SegmentationPostResponse = {
    messages: Array<UpdateSegmentMessage>;
    metadata: SegmentationMetadata;
};

/**
 * The segments layer is the main set of polygons for the project,
 * they are used for reports, analysis and other purposes.
 */
export type SegmentsLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'segments';
};

export enum type17 {
    SEGMENTS = 'segments'
}

/**
 * The segments layer is the main set of polygons for the project,
 * they are used for reports, analysis and other purposes.
 */
export type SegmentsPrefectLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'segments-prefect';
    imagery_source: null;
    model_id: string;
};

export enum type18 {
    SEGMENTS_PREFECT = 'segments-prefect'
}

/**
 * Request data for sending invoice email.
 */
export type SendInvoiceRequest = {
    to: Array<(string)>;
    task_id?: string;
};

export type ShapefileConversion = {
    geometry: {
        [key: string]: unknown;
    };
    shapefile_schema?: {
    [key: string]: unknown;
};
    shapefile_name?: string;
};

/**
 * The site boundary layer is the main set of polygons for the project,
 * they are used for reports, analysis and other purposes.
 */
export type SiteBoundaryLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'site_boundary';
};

export enum type19 {
    SITE_BOUNDARY = 'site_boundary'
}

/**
 * Feature property of site point.
 */
export type SitePointProperty = {
    customer_id: number;
};

/**
 * Summary of a site. The measures is a dictionary of dimension index to measures.
 */
export type SiteSummary = {
    customer_id: number;
    create_time: string;
    edit_time: string;
    measures: {
        [key: string]: Measures;
    };
    properties: PropertyProperties;
    site_area_m2?: number;
    location?: Location;
};

/**
 * List of sites. This uses a compact representation for metadata that allows for
 * efficient filtering and aggregation.
 *
 * The dimensions here are the independent variables that we can filter on. For
 * a simple example, let's say there was only 1 dimension, forest_type. We define
 * here the list of dimensions:
 *
 * "dimensions": {
 * "1": { "forest_type": "native"},
 * "2": { "forest_type": "exotic"}
 * }
 *
 * When it comes to our site, we don't have to repeat the forest_type, we just
 * reference the dimension by its index. For example here's a site with mostly
 * native forest:
 *
 * "sites": [
 * {
 * "customer_id": 1,
 * "measures": {
 * "1": { "area_ha": 100 },
 * "2": { "area_ha": 13 }
 * }
 * }
 * ]
 *
 * Note here that the "1" in the measures is a reference to the dimension index.
 */
export type SitesListResponse = {
    sites: Array<SiteSummary>;
    dimensions: {
        [key: string]: Dimensions;
    };
    start_year: number;
};

/**
 * General purpose layer that is used to store source data for a project.
 * This may include things like the original data that was used to
 * determine the boundary of the project.
 */
export type SourceDataLayerProperties = {
    version_created?: VersionData;
    data_type?: 'geojson';
    type: 'source_data';
    name: string;
};

export enum type20 {
    SOURCE_DATA = 'source_data'
}

export type TitleWithOwner = {
    title_no: string;
    total_area_m2: number;
    owner_list: Array<(string)>;
    parcel_list: Array<(string)>;
};

export type TitlesResponse = {
    title_list: Array<TitleWithOwner>;
};

export type TokenResponse = {
    token: string;
};

export enum TupuAkeForestTypeId {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_6' = 6
}

export enum TupuAkePredominantSpeciesId {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
    '_9' = 9,
    '_10' = 10,
    '_24' = 24,
    '_22' = 22,
    '_25' = 25,
    '_11' = 11,
    '_12' = 12,
    '_13' = 13,
    '_14' = 14,
    '_15' = 15,
    '_16' = 16,
    '_17' = 17,
    '_18' = 18,
    '_26' = 26,
    '_27' = 27,
    '_19' = 19,
    '_20' = 20
}

export enum TupuAkeTreeSpeciesId {
    '_8' = 8,
    '_9' = 9,
    '_10' = 10,
    '_175' = 175,
    '_11' = 11,
    '_13' = 13,
    '_176' = 176,
    '_177' = 177,
    '_178' = 178,
    '_179' = 179,
    '_180' = 180,
    '_14' = 14,
    '_15' = 15,
    '_181' = 181,
    '_182' = 182,
    '_183' = 183,
    '_184' = 184,
    '_185' = 185,
    '_16' = 16,
    '_186' = 186,
    '_17' = 17,
    '_19' = 19,
    '_187' = 187,
    '_188' = 188,
    '_189' = 189,
    '_22' = 22,
    '_23' = 23,
    '_24' = 24,
    '_25' = 25,
    '_26' = 26,
    '_190' = 190,
    '_32' = 32,
    '_33' = 33,
    '_34' = 34,
    '_35' = 35,
    '_36' = 36,
    '_37' = 37,
    '_38' = 38,
    '_39' = 39,
    '_40' = 40,
    '_192' = 192,
    '_193' = 193,
    '_41' = 41,
    '_194' = 194,
    '_42' = 42,
    '_43' = 43,
    '_44' = 44,
    '_45' = 45,
    '_46' = 46,
    '_47' = 47,
    '_48' = 48,
    '_49' = 49,
    '_50' = 50,
    '_51' = 51,
    '_52' = 52,
    '_53' = 53,
    '_54' = 54,
    '_55' = 55,
    '_56' = 56,
    '_57' = 57,
    '_58' = 58,
    '_59' = 59,
    '_60' = 60,
    '_61' = 61,
    '_62' = 62,
    '_63' = 63,
    '_64' = 64,
    '_65' = 65,
    '_66' = 66,
    '_195' = 195,
    '_67' = 67,
    '_197' = 197,
    '_173' = 173,
    '_68' = 68,
    '_198' = 198,
    '_199' = 199,
    '_69' = 69,
    '_200' = 200,
    '_201' = 201,
    '_70' = 70,
    '_202' = 202,
    '_71' = 71,
    '_72' = 72,
    '_174' = 174,
    '_73' = 73,
    '_203' = 203,
    '_204' = 204,
    '_205' = 205,
    '_206' = 206,
    '_74' = 74,
    '_207' = 207,
    '_75' = 75,
    '_77' = 77,
    '_80' = 80,
    '_208' = 208,
    '_209' = 209,
    '_82' = 82,
    '_83' = 83,
    '_84' = 84,
    '_210' = 210,
    '_211' = 211,
    '_212' = 212,
    '_213' = 213,
    '_85' = 85,
    '_86' = 86,
    '_87' = 87,
    '_88' = 88,
    '_89' = 89,
    '_214' = 214,
    '_215' = 215,
    '_216' = 216,
    '_90' = 90,
    '_217' = 217,
    '_218' = 218,
    '_91' = 91,
    '_92' = 92,
    '_93' = 93,
    '_94' = 94,
    '_95' = 95,
    '_96' = 96,
    '_219' = 219,
    '_220' = 220,
    '_97' = 97,
    '_98' = 98,
    '_99' = 99,
    '_100' = 100,
    '_101' = 101,
    '_102' = 102,
    '_103' = 103,
    '_104' = 104,
    '_105' = 105,
    '_221' = 221,
    '_222' = 222,
    '_223' = 223,
    '_106' = 106,
    '_107' = 107,
    '_108' = 108,
    '_109' = 109,
    '_110' = 110,
    '_111' = 111,
    '_112' = 112,
    '_131' = 131,
    '_132' = 132,
    '_135' = 135,
    '_136' = 136,
    '_137' = 137,
    '_138' = 138,
    '_139' = 139,
    '_140' = 140,
    '_224' = 224,
    '_142' = 142,
    '_143' = 143,
    '_144' = 144,
    '_145' = 145,
    '_146' = 146,
    '_147' = 147,
    '_148' = 148,
    '_149' = 149,
    '_151' = 151,
    '_225' = 225,
    '_152' = 152,
    '_153' = 153,
    '_154' = 154,
    '_155' = 155,
    '_156' = 156,
    '_226' = 226,
    '_157' = 157,
    '_227' = 227,
    '_161' = 161,
    '_228' = 228,
    '_229' = 229,
    '_230' = 230,
    '_231' = 231,
    '_232' = 232,
    '_233' = 233,
    '_234' = 234,
    '_163' = 163,
    '_164' = 164,
    '_235' = 235,
    '_236' = 236,
    '_165' = 165,
    '_166' = 166,
    '_237' = 237,
    '_168' = 168,
    '_238' = 238,
    '_169' = 169,
    '_170' = 170,
    '_171' = 171,
    '_239' = 239,
    '_240' = 240,
    '_241' = 241,
    '_242' = 242,
    '_243' = 243,
    '_244' = 244,
    '_245' = 245
}

/**
 * Message data Model for segment layer update.
 */
export type UpdateSegmentMessage = {
    feature_id?: string | number;
    code: string;
    detail: string;
};

/**
 * Reference to a user in our DB
 */
export type User = {
    email?: string;
    user_id?: number;
};

/**
 * Response for creating a user.
 */
export type UserCompanyRelations = {
    company_id: number;
    tags: Array<CompanyUserTags>;
};

/**
 * Add the specific tags for a customer to the user information
 */
export type UserInfoCustomerTagsResponse = {
    email: string;
    first_name?: string;
    last_name?: string;
    user_id: number;
    status?: number;
    tags: Array<(string)>;
    user_customer_tags: Array<CustomerUserTags>;
};

/**
 * Detailed information about a single user
 */
export type UserInfoResponse = {
    email: string;
    first_name?: string;
    last_name?: string;
    user_id: number;
    status?: number;
    tags: Array<(string)>;
};

/**
 * User data for query/create user.
 *
 * Only email is required when querying a existing user.
 */
export type UserPost = {
    email: string;
    first_name?: string;
    last_name?: string;
};

/**
 * User data for query/create user with mobile.
 */
export type UserPostWithMobile = {
    email: string;
    first_name?: string;
    last_name?: string;
    mobile?: string;
};

/**
 * User data for updating user.
 */
export type UserPut = {
    email?: string;
    first_name?: string;
    last_name?: string;
};

/**
 * Response for creating a user.
 */
export type UsersCompanyListResponse = {
    companies: Array<UserCompanyRelations>;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
};

/**
 * Metadata about a version of a layer
 */
export type VersionData = {
    user_id: number;
    timestamp: string;
};

/**
 * A list of version for a single layer
 */
export type VersionListModel = {
    customer_id: number;
    layer_id: number;
    version_list: Array<VersionModel_AllLayerProperties_>;
};

export type VersionModel_AllLayerProperties_ = {
    version_id: number;
    properties: AllLayerProperties;
    is_latest: boolean;
};

/**
 * A prediction of carbon sequestration. The year corresponds to
 * the year in which the sequestration happened. For example the 2023 credit sale
 * potential is for sequestration that happened from 1st Jan 2023 to 31st December 2023
 */
export type YieldPotential = {
    mean_annual_yield: number;
    total_yield_to_2050: number;
    yields: {
        [key: string]: (number);
    };
};

/**
 * Yield data for one CAA
 */
export type YieldsForCAA = {
    caa_number?: number;
    feature_ids: Array<IdTypes>;
    area_ha: number;
    yields: {
        [key: string]: (number);
    };
};

export type api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___1 = {
    type: 'FeatureCollection';
    features: Array<Feature_IdTypes_Union_Point__NoneType__PhotoTakenProperties_>;
    metadata?: null;
};

export type api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___2 = {
    type: 'FeatureCollection';
    features: Array<Feature_IdTypes_Union_Point__NoneType__PhotoTakenProperties_>;
    metadata?: null;
};

export type PostAvailableImageryData = {
    fullCoverage?: boolean | null;
    requestBody: FeatureCollection_IdTypes_Union_Polygon__MultiPolygon___FeaturePropertyType__CollectionMetadataType_;
    sourcesToCheck?: Array<('mapbox_imagery' | 'linz_base_map' | 'linz_topographical' | 'linz_aerial_imagery' | 'linz_historical_imagery' | 'retrolens' | 'retrolens_hd' | 'retrolens_hd_survey' | 'planet_imagery' | 'landsat_imagery')> | null;
};

export type PostAvailableImageryResponse = AvailableImageryResponse;

export type PostCcuData = {
    requestBody: CcuTraceRequest;
};

export type PostCcuResponse = unknown;

export type GetCcuData = {
    ccuId: number;
};

export type GetCcuResponse = CcuTraceResponse;

export type GetCcuForecastResponse = CarbonPrices;

export type GetCompaniesResponse = Array<CompanyResponse>;

export type PostCompaniesData = {
    requestBody: CreateCompanyPost;
};

export type PostCompaniesResponse = CompanyResponse;

export type GetCompanyData = {
    companyId: number;
};

export type GetCompanyResponse = CompanyResponse;

export type GetCompanyAccessData = {
    companyId: number;
};

export type GetCompanyAccessResponse = GetAccessResponse;

export type PutCompanyCustomSpeciesData = {
    companyId: number;
    requestBody: CustomSpeciesData;
};

export type PutCompanyCustomSpeciesResponse = unknown;

export type GetCompanyCustomSpeciesData = {
    companyId: number;
};

export type GetCompanyCustomSpeciesResponse = CustomSpeciesData;

export type DeleteCompanyCustomSpeciesData = {
    companyId: number;
};

export type DeleteCompanyCustomSpeciesResponse = unknown;

export type GetCompanyPropertiesData = {
    companyId: number;
};

export type GetCompanyPropertiesResponse = CompanyProperties;

export type PutCompanyPropertiesData = {
    companyId: number;
    requestBody: CompanyProperties;
};

export type PutCompanyPropertiesResponse = unknown;

export type PutCompanyPropertiesParticipantSpecificTableXlsData = {
    companyId: number;
    formData: Body_put_company_properties_participant_specific_table_xls;
};

export type PutCompanyPropertiesParticipantSpecificTableXlsResponse = ParticipantSpecificTable;

export type GetCompanyTasksData = {
    companyId: number;
};

export type GetCompanyTasksResponse = Array<(Per2023Task | Per2024Task | InvoiceTask | GenericTask)>;

export type GetCompanyUsersData = {
    companyId: number;
};

export type GetCompanyUsersResponse = Array<CompanyUserResponse>;

export type PostCompanyUsersInvitationData = {
    companyId: number;
    requestBody: InviteCompanyUserPost;
};

export type PostCompanyUsersInvitationResponse = CompanyUserResponse;

export type GetCompanyUserData = {
    companyId: number;
    userId: number;
};

export type GetCompanyUserResponse = Array<CompanyUserTags>;

export type DeleteCompanyUserTagsAllData = {
    companyId: number;
    userId: number;
};

export type DeleteCompanyUserTagsAllResponse = void;

export type PostCompanyUserData = {
    companyId: number;
    tagname: CompanyUserTags;
    userId: number;
};

export type PostCompanyUserResponse = unknown;

export type DeleteCompanyUserData = {
    companyId: number;
    tagname: CompanyUserTags;
    userId: number;
};

export type DeleteCompanyUserResponse = unknown;

export type PostCtrData = {
    requestBody: Feature_IdTypes_Union_Polygon__MultiPolygon__Dict_str__Any__;
};

export type PostCtrResponse = unknown;

export type GetCtrShapefileResponse = unknown;

export type GetCtrData = {
    ctrId: number;
};

export type GetCtrResponse = CtrTraceResponse;

export type GetCustomersResponse = Array<CustomerId>;

export type GetCustomersOverviewResponse = FeatureCollection_NoneType_Point_SitePointProperty_NoneType_;

export type GetCustomerAccessData = {
    customerId: number;
};

export type GetCustomerAccessResponse = GetAccessResponse;

export type PostCustomerAltcertEvaluateData = {
    customerId: number;
};

export type PostCustomerAltcertEvaluateResponse = unknown;

export type GetCustomerBalanceForwardData = {
    customerId: number;
};

export type GetCustomerBalanceForwardResponse = BalanceForwardResponse;

export type GetCustomerBillingAddressData = {
    customerId: number;
};

export type GetCustomerBillingAddressResponse = AddressAnswer;

export type GetCustomerBoundaryData = {
    customerId: number;
    dissolve?: boolean;
    inverted?: boolean;
};

export type GetCustomerBoundaryResponse = FeatureCollection;

export type GetCustomerCaasYieldsData = {
    customerId: number;
    segmentsVersionId?: number | null;
};

export type GetCustomerCaasYieldsResponse = Array<YieldsForCAA>;

export type PostCustomerCarbonStockPipelineEtsEvaluateData = {
    customerId: number;
    overwriteSegments?: boolean;
};

export type PostCustomerCarbonStockPipelineEtsEvaluateResponse = unknown;

export type PostCustomerCarbonStockPipelineRunFlowData = {
    customerId: number;
    /**
     * The deployment id of the Prefect flow to trigger.
     */
    deploymentId: string;
    /**
     * The name of the Prefect flow to trigger (e.g. ETS-flow). Will be set as tag.
     */
    flowName?: string;
    requestBody?: {
    [key: string]: unknown;
};
};

export type PostCustomerCarbonStockPipelineRunFlowResponse = unknown;

export type GetCustomerCompanyData = {
    customerCompanyTag: CompanyCustomerTags;
    customerId: number;
};

export type GetCustomerCompanyResponse = CompanyPropertiesResponse;

export type PostCustomerCompanyData = {
    customerCompanyTag: CompanyCustomerTags;
    customerId: number;
    requestBody: ChangeCarbonManagerRequest;
};

export type PostCustomerCompanyResponse = unknown;

export type DeleteCustomerCompanyData = {
    customerCompanyTag: CompanyCustomerTags;
    customerId: number;
};

export type DeleteCustomerCompanyResponse = unknown;

export type GetCustomerCompanyCustomSpeciesData = {
    customerCompanyTag: CompanyCustomerTags;
    customerId: number;
};

export type GetCustomerCompanyCustomSpeciesResponse = CustomSpeciesData;

export type GetCustomerCompanyCustomSpeciesSummaryData = {
    customerCompanyTag: CompanyCustomerTags;
    customerId: number;
};

export type GetCustomerCompanyCustomSpeciesSummaryResponse = CustomSpeciesSummaryList;

export type GetCustomerCreditNotesData = {
    customerId: number;
};

export type GetCustomerCreditNotesResponse = Array<QueryCreditNoteResponse>;

export type PostCustomerEconomicsByFeatureData = {
    customerId: number;
    requestBody: Feature_IdTypes_Union_Polygon__MultiPolygon__CommonGeoJsonProperties_;
    startYear?: number;
    totalArea?: number;
};

export type PostCustomerEconomicsByFeatureResponse = BlockEconomics;

export type PostCustomerEconomicsUpdateData = {
    customerId: number;
};

export type PostCustomerEconomicsUpdateResponse = void;

export type GetCustomerEtsLandDistrictData = {
    customerId: number;
};

export type GetCustomerEtsLandDistrictResponse = Array<('AUCKLAND' | 'WAIKATO/TAUPO' | 'BAY OF PLENTY' | 'GISBORNE' | 'HAWKES BAY/SOUTHERN NORTH ISLAND' | 'NELSON/MARLBOROUGH' | 'CANTERBURY/WEST COAST' | 'OTAGO' | 'SOUTHLAND')>;

export type GetCustomerGdriveData = {
    customerId: number;
};

export type GetCustomerGdriveResponse = string;

export type PostCustomerGdriveData = {
    customerId: number;
    formData: Body_post_customer_gdrive;
    internalPath: string;
};

export type PostCustomerGdriveResponse = unknown;

export type PostCustomerInvoicesData = {
    customerId: number;
    requestBody: InvoicePostRequest;
};

export type PostCustomerInvoicesResponse = InvoiceDataResponse;

export type GetCustomerInvoicesData = {
    customerId: number;
};

export type GetCustomerInvoicesResponse = Array<InvoiceDataResponse>;

export type GetCustomerInvoicePdfData = {
    customerId: number;
    invoiceId: number;
};

export type GetCustomerInvoicePdfResponse = unknown;

export type DeleteCustomerInvoiceData = {
    customerId: number;
    invoiceId: number;
};

export type DeleteCustomerInvoiceResponse = unknown;

export type GetCustomerInvoiceFileIdData = {
    customerId: number;
    invoiceId: number;
};

export type GetCustomerInvoiceFileIdResponse = InvoiceGoogleDriveFileIdResponse;

export type GetCustomerInvoicePaymentsData = {
    customerId: number;
    invoiceId: number;
};

export type GetCustomerInvoicePaymentsResponse = Array<PaymentResponseData>;

export type PutCustomerInvoicePaymentStatusData = {
    customerId: number;
    invoiceId: number;
    paymentId: number;
    requestBody: PaymentStatusUpdateRequest;
};

export type PutCustomerInvoicePaymentStatusResponse = PaymentResponseData;

export type PutCustomerInvoicePropertiesData = {
    customerId: number;
    invoiceId: number;
    requestBody: InvoiceCalculationMinimal;
};

export type PutCustomerInvoicePropertiesResponse = InvoiceDataResponse;

export type PutCustomerInvoicePropertiesNzusIssuedData = {
    customerId: number;
    invoiceId: number;
    requestBody: InvoiceCalculationMinimal;
};

export type PutCustomerInvoicePropertiesNzusIssuedResponse = InvoiceDataResponse;

export type PostCustomerInvoiceSendData = {
    customerId: number;
    invoiceId: number;
    requestBody: SendInvoiceRequest;
};

export type PostCustomerInvoiceSendResponse = unknown;

export type PutCustomerInvoiceStatusData = {
    customerId: number;
    invoiceId: number;
    requestBody: InvoiceStatusUpdateRequest;
};

export type PutCustomerInvoiceStatusResponse = InvoiceDataResponse;

export type GetCustomerKmlFileData = {
    customerId: number;
};

export type GetCustomerKmlFileResponse = unknown;

export type PostCustomerLayersData = {
    customerId: number;
    requestBody: LayerPost_AllLayerProperties_IdTypes_GeometryTypes_PropertyTypes_;
};

export type PostCustomerLayersResponse = LayerModel;

export type GetCustomerLayersData = {
    customerId: number;
    ifNoneMatch?: string | null;
};

export type GetCustomerLayersResponse = LayerListModel;

export type PostCustomerLayerData = {
    customerId: number;
    layerId: number;
    requestBody: LayerPost_AllLayerProperties_IdTypes_GeometryTypes_PropertyTypes_;
};

export type PostCustomerLayerResponse = LayerModel;

export type GetCustomerLayerData = {
    customerId: number;
    ifNoneMatch?: string | null;
    layerId: number;
    versionId?: number | null;
};

export type GetCustomerLayerResponse = FeatureCollectionWithId_GeometryTypes_PropertyTypes_NoneType_;

export type DeleteCustomerLayerData = {
    customerId: number;
    layerId: number;
};

export type DeleteCustomerLayerResponse = {
    [key: string]: (string);
};

export type GetCustomerLayerVersionsData = {
    customerId: number;
    layerId: number;
};

export type GetCustomerLayerVersionsResponse = VersionListModel;

export type GetCustomerMeasuresData = {
    customerId: number;
    segmentsVersionId?: number | null;
};

export type GetCustomerMeasuresResponse = Array<DimsAndMeasures>;

export type GetCustomerParcelstatusData = {
    customerId: number;
};

export type GetCustomerParcelstatusResponse = ParcelStatusResponse;

export type PostCustomerPerEmailData = {
    customerId: number;
    requestBody: PerEmailPost;
};

export type PostCustomerPerEmailResponse = unknown;

export type GetCustomerPhotosRequestedPointsData = {
    customerId: number;
};

export type GetCustomerPhotosRequestedPointsResponse = FeatureCollection;

export type PostCustomerPhotosRequestedPointsData = {
    customerId: number;
    requestBody: {
        [key: string]: unknown;
    };
};

export type PostCustomerPhotosRequestedPointsResponse = unknown;

export type PostCustomerPhotosTakenData = {
    customerId: number;
    formData: Body_post_customer_photos_taken;
};

export type PostCustomerPhotosTakenResponse = api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___1;

export type GetCustomerPhotosTakenData = {
    customerId: number;
    fileId: string;
    size?: string | null;
};

export type GetCustomerPhotosTakenResponse = unknown;

export type DeleteCustomerPhotosTakenData = {
    customerId: number;
    fileId: string;
};

export type DeleteCustomerPhotosTakenResponse = unknown;

export type PutCustomerPhotosTakenArchivedData = {
    customerId: number;
    fileId: string;
    requestBody: PhotoArchivedBody;
};

export type PutCustomerPhotosTakenArchivedResponse = unknown;

export type GetCustomerPhotosTakenPointsData = {
    customerId: number;
};

export type GetCustomerPhotosTakenPointsResponse = api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___2;

export type GetCustomerPropertiesData = {
    customerId: number;
};

export type GetCustomerPropertiesResponse = CustomerProperties;

export type PostCustomerPropertiesData = {
    customerId: number;
    requestBody: CustomerProperties;
};

export type PostCustomerPropertiesResponse = CustomerProperties;

export type GetCustomerSegmentationFeaturePropertyData = {
    customerId: number;
    featureId: number;
    topLevelProperty: string;
};

export type GetCustomerSegmentationFeaturePropertyResponse = unknown;

export type PatchCustomerSegmentationFeaturePropertyData = {
    customerId: number;
    featureId: number;
    requestBody: {
    [key: string]: unknown;
} | string | number;
    topLevelProperty: string;
};

export type PatchCustomerSegmentationFeaturePropertyResponse = {
    [key: string]: unknown;
};

export type PostCustomerSegmentsData = {
    customerId: number;
    requestBody: CustomerSegmentationPost;
};

export type PostCustomerSegmentsResponse = SegmentationPostResponse;

export type GetCustomerSegmentsData = {
    customerId: number;
    ifNoneMatch?: string | null;
    versionId?: number | null;
};

export type GetCustomerSegmentsResponse = FeatureCollection_IdTypes_GeometryTypes_CommonGeoJsonProperties_SegmentationMetadata_;

export type PostCustomerSegmentsEtsRegistrationData = {
    customerId: number;
    requestBody: CustomerSegmentationPost;
};

export type PostCustomerSegmentsEtsRegistrationResponse = unknown;

export type GetCustomerSegmentsEtsRegistrationData = {
    customerId: number;
    versionId?: number | null;
};

export type GetCustomerSegmentsEtsRegistrationResponse = FeatureCollection_IdTypes_GeometryTypes_PropertyTypes_SegmentationMetadata_;

export type GetCustomerTasksData = {
    customerId: number;
};

export type GetCustomerTasksResponse = Array<(Per2023Task | Per2024Task | InvoiceTask | GenericTask)>;

export type PutCustomerTasksData = {
    customerId: number;
    requestBody: Per2023Task | Per2024Task | InvoiceTask | GenericTask;
};

export type PutCustomerTasksResponse = unknown;

export type PostCustomerTasksInvoiceData = {
    customerId: number;
};

export type PostCustomerTasksInvoiceResponse = unknown;

export type DeleteCustomerTaskData = {
    customerId: number;
    taskUuid: string;
};

export type DeleteCustomerTaskResponse = unknown;

export type PostCustomerTitlesData = {
    customerId: number;
    requestBody: Array<(string)>;
    runAi?: boolean;
};

export type PostCustomerTitlesResponse = unknown;

export type GetCustomerTitlesData = {
    customerId: number;
};

export type GetCustomerTitlesResponse = TitlesResponse;

export type GetCustomerTokenData = {
    customerId: number;
};

export type GetCustomerTokenResponse = string;

export type GetCustomerUsersData = {
    customerId: number;
};

export type GetCustomerUsersResponse = CustomerUsersResponse;

export type PostCustomerUsersInvitationData = {
    customerId: number;
    requestBody: InviteSiteUserPost;
};

export type PostCustomerUsersInvitationResponse = unknown;

export type DeleteCustomerUserData = {
    customerId: number;
    userId: number;
};

export type DeleteCustomerUserResponse = unknown;

export type PostCustomerUserTagData = {
    customerId: number;
    tagname: CustomerUserTags;
    userId: number;
};

export type PostCustomerUserTagResponse = unknown;

export type DeleteCustomerUserTagData = {
    customerId: number;
    tagname: CustomerUserTags;
    userId: number;
};

export type DeleteCustomerUserTagResponse = unknown;

export type GetHubspotDealData = {
    customerId: number;
};

export type GetHubspotDealResponse = Array<{
    [key: string]: unknown;
}>;

export type PostHubspotDealPropertiesData = {
    customerId: number;
    requestBody: HubspotDealProperties;
};

export type PostHubspotDealPropertiesResponse = HubspotDealUpdateResponse;

export type GetNzuForecastResponse = CarbonPrices;

export type DeleteSiteUserData = {
    siteId: number;
    userId: number;
};

export type DeleteSiteUserResponse = unknown;

export type PostUsersData = {
    requestBody: UserPost;
};

export type PostUsersResponse = CreateUserResponse;

export type GetUsersData = {
    email: string;
};

export type GetUsersResponse = Array<UserInfoResponse>;

export type GetUsersMeResponse = UserInfoResponse;

export type GetUsersMeCompaniesResponse = UsersCompanyListResponse;

export type GetUsersMeCustomersResponse = Array<CustomersForUser>;

export type GetUsersMeTokenResponse = TokenResponse;

export type GetUserData = {
    userId: number;
};

export type GetUserResponse = UserInfoResponse;

export type PutUserData = {
    requestBody: UserPut;
    userId: number;
};

export type PutUserResponse = unknown;

export type DeleteUserData = {
    userId: number;
};

export type DeleteUserResponse = unknown;

export type GetUserCompaniesData = {
    userId: number;
};

export type GetUserCompaniesResponse = UsersCompanyListResponse;

export type GetUserCustomersData = {
    userId: number;
};

export type GetUserCustomersResponse = Array<CustomersForUser>;

export type GetCompanyCustomersV2Data = {
    companyId: number;
};

export type GetCompanyCustomersV2Response = SitesListResponse;

export type PostCustomersV2Data = {
    requestBody: CreateUserCustomerPost;
};

export type PostCustomersV2Response = CreateCustomerResponse;

export type GetCustomerEconomicsV2Data = {
    customerId: number;
    segmentsVersionId?: number | null;
    status?: Array<('draft' | 'rejected' | 'registered' | 'submitted')> | null;
};

export type GetCustomerEconomicsV2Response = GetFinancePlanResponse;

export type PostCustomerEconomicsV2Data = {
    customerId: number;
};

export type PostCustomerEconomicsV2Response = unknown;

export type PostCustomerShapefileV2Data = {
    customerId: number;
    requestBody: ShapefileConversion;
};

export type PostCustomerShapefileV2Response = unknown;

export type PutCustomerTasksInvoiceV2Data = {
    customerId: number;
    /**
     * The parent task to associate this invoice with
     */
    parentTaskId: string;
};

export type PutCustomerTasksInvoiceV2Response = unknown;

export type GetVersionResponse = unknown;

export type GetResponse = unknown;

export type GetDocsResponse = unknown;

export type $OpenApiTs = {
    '/api/v1/available_imagery': {
        post: {
            req: PostAvailableImageryData;
            res: {
                /**
                 * Successful Response
                 */
                200: AvailableImageryResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/ccu': {
        post: {
            req: PostCcuData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/ccu/{ccu_id}': {
        get: {
            req: GetCcuData;
            res: {
                /**
                 * Successful Response
                 */
                200: CcuTraceResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/ccu_forecast': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: CarbonPrices;
            };
        };
    };
    '/api/v1/companies': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CompanyResponse>;
            };
        };
        post: {
            req: PostCompaniesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CompanyResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}': {
        get: {
            req: GetCompanyData;
            res: {
                /**
                 * Successful Response
                 */
                200: CompanyResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/access': {
        get: {
            req: GetCompanyAccessData;
            res: {
                /**
                 * Successful Response
                 */
                200: GetAccessResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/custom_species': {
        put: {
            req: PutCompanyCustomSpeciesData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCompanyCustomSpeciesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomSpeciesData;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCompanyCustomSpeciesData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/properties': {
        get: {
            req: GetCompanyPropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CompanyProperties;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        put: {
            req: PutCompanyPropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/properties/participant_specific_table.xls': {
        put: {
            req: PutCompanyPropertiesParticipantSpecificTableXlsData;
            res: {
                /**
                 * Successful Response
                 */
                200: ParticipantSpecificTable;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/tasks': {
        get: {
            req: GetCompanyTasksData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<(Per2023Task | Per2024Task | InvoiceTask | GenericTask)>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/users': {
        get: {
            req: GetCompanyUsersData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CompanyUserResponse>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/users/invitation': {
        post: {
            req: PostCompanyUsersInvitationData;
            res: {
                /**
                 * Successful Response
                 */
                200: CompanyUserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/users/{user_id}': {
        get: {
            req: GetCompanyUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CompanyUserTags>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/users/{user_id}/tags/all': {
        delete: {
            req: DeleteCompanyUserTagsAllData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/companies/{company_id}/users/{user_id}/{tagname}': {
        post: {
            req: PostCompanyUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCompanyUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/ctr': {
        post: {
            req: PostCtrData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/ctr/shapefile': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/api/v1/ctr/{ctr_id}': {
        get: {
            req: GetCtrData;
            res: {
                /**
                 * Successful Response
                 */
                200: CtrTraceResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CustomerId>;
            };
        };
    };
    '/api/v1/customers/overview': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollection_NoneType_Point_SitePointProperty_NoneType_;
            };
        };
    };
    '/api/v1/customers/{customer_id}/access': {
        get: {
            req: GetCustomerAccessData;
            res: {
                /**
                 * Successful Response
                 */
                200: GetAccessResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/altcert/evaluate': {
        post: {
            req: PostCustomerAltcertEvaluateData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/balance_forward': {
        get: {
            req: GetCustomerBalanceForwardData;
            res: {
                /**
                 * Successful Response
                 */
                200: BalanceForwardResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/billing_address': {
        get: {
            req: GetCustomerBillingAddressData;
            res: {
                /**
                 * Successful Response
                 */
                200: AddressAnswer;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/boundary': {
        get: {
            req: GetCustomerBoundaryData;
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollection;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/caas/yields': {
        get: {
            req: GetCustomerCaasYieldsData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<YieldsForCAA>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/carbon_stock_pipeline/ets/evaluate': {
        post: {
            req: PostCustomerCarbonStockPipelineEtsEvaluateData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/carbon_stock_pipeline/run_flow': {
        post: {
            req: PostCustomerCarbonStockPipelineRunFlowData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/companies/{customer_company_tag}': {
        get: {
            req: GetCustomerCompanyData;
            res: {
                /**
                 * Successful Response
                 */
                200: CompanyPropertiesResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: PostCustomerCompanyData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCustomerCompanyData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/companies/{customer_company_tag}/custom_species': {
        get: {
            req: GetCustomerCompanyCustomSpeciesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomSpeciesData;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/companies/{customer_company_tag}/custom_species/summary': {
        get: {
            req: GetCustomerCompanyCustomSpeciesSummaryData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomSpeciesSummaryList;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/credit_notes': {
        get: {
            req: GetCustomerCreditNotesData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<QueryCreditNoteResponse>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/economics/by_feature': {
        post: {
            req: PostCustomerEconomicsByFeatureData;
            res: {
                /**
                 * Successful Response
                 */
                200: BlockEconomics;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/economics/update': {
        post: {
            req: PostCustomerEconomicsUpdateData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/ets_land_district': {
        get: {
            req: GetCustomerEtsLandDistrictData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<('AUCKLAND' | 'WAIKATO/TAUPO' | 'BAY OF PLENTY' | 'GISBORNE' | 'HAWKES BAY/SOUTHERN NORTH ISLAND' | 'NELSON/MARLBOROUGH' | 'CANTERBURY/WEST COAST' | 'OTAGO' | 'SOUTHLAND')>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/gdrive': {
        get: {
            req: GetCustomerGdriveData;
            res: {
                /**
                 * Successful Response
                 */
                200: string;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/gdrive/{internal_path}': {
        post: {
            req: PostCustomerGdriveData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices': {
        post: {
            req: PostCustomerInvoicesData;
            res: {
                /**
                 * Successful Response
                 */
                200: InvoiceDataResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerInvoicesData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<InvoiceDataResponse>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}.pdf': {
        get: {
            req: GetCustomerInvoicePdfData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}': {
        delete: {
            req: DeleteCustomerInvoiceData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/file_id': {
        get: {
            req: GetCustomerInvoiceFileIdData;
            res: {
                /**
                 * Successful Response
                 */
                200: InvoiceGoogleDriveFileIdResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/payments': {
        get: {
            req: GetCustomerInvoicePaymentsData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<PaymentResponseData>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/payments/{payment_id}/status': {
        put: {
            req: PutCustomerInvoicePaymentStatusData;
            res: {
                /**
                 * Successful Response
                 */
                200: PaymentResponseData;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/properties': {
        put: {
            req: PutCustomerInvoicePropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: InvoiceDataResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/properties/nzus_issued': {
        put: {
            req: PutCustomerInvoicePropertiesNzusIssuedData;
            res: {
                /**
                 * Successful Response
                 */
                200: InvoiceDataResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/send': {
        post: {
            req: PostCustomerInvoiceSendData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/invoices/{invoice_id}/status': {
        put: {
            req: PutCustomerInvoiceStatusData;
            res: {
                /**
                 * Successful Response
                 */
                200: InvoiceDataResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/kml_file': {
        get: {
            req: GetCustomerKmlFileData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/layers': {
        post: {
            req: PostCustomerLayersData;
            res: {
                /**
                 * Successful Response
                 */
                201: LayerModel;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerLayersData;
            res: {
                /**
                 * Successful Response
                 */
                200: LayerListModel;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/layers/{layer_id}': {
        post: {
            req: PostCustomerLayerData;
            res: {
                /**
                 * Successful Response
                 */
                201: LayerModel;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerLayerData;
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollectionWithId_GeometryTypes_PropertyTypes_NoneType_;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCustomerLayerData;
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: (string);
                };
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/layers/{layer_id}/versions': {
        get: {
            req: GetCustomerLayerVersionsData;
            res: {
                /**
                 * Successful Response
                 */
                200: VersionListModel;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/measures': {
        get: {
            req: GetCustomerMeasuresData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<DimsAndMeasures>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/parcelstatus': {
        get: {
            req: GetCustomerParcelstatusData;
            res: {
                /**
                 * Successful Response
                 */
                200: ParcelStatusResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/per_email': {
        post: {
            req: PostCustomerPerEmailData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/photos/requested_points': {
        get: {
            req: GetCustomerPhotosRequestedPointsData;
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollection;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: PostCustomerPhotosRequestedPointsData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/photos/taken': {
        post: {
            req: PostCustomerPhotosTakenData;
            res: {
                /**
                 * Successful Response
                 */
                200: api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___1;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/photos/taken/{file_id}': {
        get: {
            req: GetCustomerPhotosTakenData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCustomerPhotosTakenData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/photos/taken/{file_id}/archived': {
        put: {
            req: PutCustomerPhotosTakenArchivedData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/photos/taken_points': {
        get: {
            req: GetCustomerPhotosTakenPointsData;
            res: {
                /**
                 * Successful Response
                 */
                200: api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___2;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/properties': {
        get: {
            req: GetCustomerPropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomerProperties;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: PostCustomerPropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomerProperties;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/segmentation/features/{feature_id}/properties/{top_level_property}': {
        get: {
            req: GetCustomerSegmentationFeaturePropertyData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: PatchCustomerSegmentationFeaturePropertyData;
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: unknown;
                };
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/segments': {
        post: {
            req: PostCustomerSegmentsData;
            res: {
                /**
                 * Successful Response
                 */
                200: SegmentationPostResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerSegmentsData;
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollection_IdTypes_GeometryTypes_CommonGeoJsonProperties_SegmentationMetadata_;
                /**
                 * Not Modified
                 */
                304: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/segments/ets/registration': {
        post: {
            req: PostCustomerSegmentsEtsRegistrationData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerSegmentsEtsRegistrationData;
            res: {
                /**
                 * Successful Response
                 */
                200: FeatureCollection_IdTypes_GeometryTypes_PropertyTypes_SegmentationMetadata_;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/tasks': {
        get: {
            req: GetCustomerTasksData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<(Per2023Task | Per2024Task | InvoiceTask | GenericTask)>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        put: {
            req: PutCustomerTasksData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/tasks/invoice': {
        post: {
            req: PostCustomerTasksInvoiceData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/tasks/{task_uuid}': {
        delete: {
            req: DeleteCustomerTaskData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/titles': {
        post: {
            req: PostCustomerTitlesData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetCustomerTitlesData;
            res: {
                /**
                 * Successful Response
                 */
                200: TitlesResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/token': {
        get: {
            req: GetCustomerTokenData;
            res: {
                /**
                 * Successful Response
                 */
                200: string;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/users': {
        get: {
            req: GetCustomerUsersData;
            res: {
                /**
                 * Successful Response
                 */
                200: CustomerUsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/users/invitation': {
        post: {
            req: PostCustomerUsersInvitationData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/users/{user_id}': {
        delete: {
            req: DeleteCustomerUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/customers/{customer_id}/users/{user_id}/tags/{tagname}': {
        post: {
            req: PostCustomerUserTagData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteCustomerUserTagData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/hubspot/deals/{customer_id}': {
        get: {
            req: GetHubspotDealData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<{
    [key: string]: unknown;
}>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/hubspot/deals/{customer_id}/properties': {
        post: {
            req: PostHubspotDealPropertiesData;
            res: {
                /**
                 * Successful Response
                 */
                200: HubspotDealUpdateResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/nzu_forecast': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: CarbonPrices;
            };
        };
    };
    '/api/v1/sites/{site_id}/users/{user_id}': {
        delete: {
            req: DeleteSiteUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/users': {
        post: {
            req: PostUsersData;
            res: {
                /**
                 * Successful Response
                 */
                201: CreateUserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetUsersData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<UserInfoResponse>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/users/me': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: UserInfoResponse;
            };
        };
    };
    '/api/v1/users/me/companies': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: UsersCompanyListResponse;
            };
        };
    };
    '/api/v1/users/me/customers': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CustomersForUser>;
            };
        };
    };
    '/api/v1/users/me/token': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: TokenResponse;
            };
        };
    };
    '/api/v1/users/{user_id}': {
        get: {
            req: GetUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserInfoResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        put: {
            req: PutUserData;
            res: {
                /**
                 * Successful Response
                 */
                201: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteUserData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/users/{user_id}/companies': {
        get: {
            req: GetUserCompaniesData;
            res: {
                /**
                 * Successful Response
                 */
                200: UsersCompanyListResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v1/users/{user_id}/customers': {
        get: {
            req: GetUserCustomersData;
            res: {
                /**
                 * Successful Response
                 */
                200: Array<CustomersForUser>;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v2/companies/{company_id}/customers': {
        get: {
            req: GetCompanyCustomersV2Data;
            res: {
                /**
                 * Successful Response
                 */
                200: SitesListResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v2/customers': {
        post: {
            req: PostCustomersV2Data;
            res: {
                /**
                 * Successful Response
                 */
                201: CreateCustomerResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v2/customers/{customer_id}/economics': {
        get: {
            req: GetCustomerEconomicsV2Data;
            res: {
                /**
                 * Successful Response
                 */
                200: GetFinancePlanResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: PostCustomerEconomicsV2Data;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v2/customers/{customer_id}/shapefile': {
        post: {
            req: PostCustomerShapefileV2Data;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/v2/customers/{customer_id}/tasks/invoice': {
        put: {
            req: PutCustomerTasksInvoiceV2Data;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/api/version': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/docs': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
};